import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import "../../styles/LearningPlans.css";
import { coverForPlan } from "../../catalogCovers";

const LearningPlans = () => {
    const [plans, setPlans] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        fetch("/api/learningplans")
            .then(async (res) => {
                const text = await res.text();
                if (!res.ok) {
                    throw new Error(`Learning plans unavailable (${res.status})`);
                }
                try {
                    return JSON.parse(text);
                } catch (e) {
                    throw new Error("Learning plans response was not JSON");
                }
            })
            .then((data) => {
                if (!cancelled) {
                    setPlans(Array.isArray(data) ? data : []);
                    setError(null);
                }
            })
            .catch((err) => {
                if (!cancelled) {
                    setPlans([]);
                    setError(err.message || "Could not load learning plans");
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false);
                }
            });
        return () => {
            cancelled = true;
        };
    }, []);

    useEffect(() => {
        fetch("/api/categories")
            .then((res) => (res.ok ? res.json() : []))
            .then((data) => setCategories(Array.isArray(data) ? data : []))
            .catch(() => setCategories([]));
    }, []);

    const filteredPlans = plans.filter((plan) =>
        selectedCategory === ""
        || plan.categoryName === selectedCategory
        || plan.category?.name === selectedCategory
    );

    if (loading) return <div className="lp-loading">Loading learning plans...</div>;
    if (error) {
        return (
            <div className="lp-container">
                <h1 className="lp-title">Learning Plans</h1>
                <p className="lp-error">{error}</p>
            </div>
        );
    }

    return (
        <div className="lp-container">
            <h1 className="lp-title">Available Learning Plans</h1>
            <p className="lp-subtitle">
                A learning plan is a group of courses you can take as one path.
                Individual courses stay available on their own.
            </p>

            <div className="category-filter">
                <label htmlFor="category">Filter by Category:</label>
                <select id="category" value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)}>
                    <option value="">All Categories</option>
                    {categories.map(cat => (
                        <option key={cat.id} value={cat.name}>{cat.name}</option>
                    ))}
                </select>
            </div>

            {filteredPlans.length === 0 ? (
                <p className="lp-empty">No learning plans in this category yet.</p>
            ) : (
                <div className="lp-grid">
                    {filteredPlans.map((plan) => {
                        const courseCount = Array.isArray(plan.courses) ? plan.courses.length : (plan.courseIds || []).length;
                        return (
                            <Link to={`/learningplans/${plan.id}`} key={plan.id} className="lp-card">
                                <img className="lp-card-cover" src={coverForPlan(plan)} alt="" />
                                <div className="lp-card-content">
                                    <h2 className="lp-card-title">{plan.title}</h2>
                                    <p className="lp-card-description">{plan.description}</p>
                                    <p className="lp-meta">{courseCount} course{courseCount === 1 ? "" : "s"}{plan.categoryName ? ` · ${plan.categoryName}` : ""}</p>
                                    <p className="lp-card-creator">Created by: <strong>{plan.createdBy}</strong></p>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default LearningPlans;
